;(function() {
  'use strict'

  angular.module('app.core').component('channelInstructions', {
    templateUrl: 'channel-instructions.html',
    transclude: true,
  })
})()
